$(document).ready(function () {
    activateFormLineControlPlaceholder();
});

function activateFormLineControlPlaceholder() {
    setTimeout(() => {
        $(".form-line .form-control").each(function () {
            if ($(this).val() !== '') {
                $(this).closest('.form-line').addClass('focused');
            }
        });
        $(".form-line .form-control").focus(function () {
            $(this).closest(".form-line").addClass("focused");
        });
        $(".form-line .form-control").focusout(function () {
            if ($(this).val() == '') {
                $(this).closest('.form-line').removeClass('focused');
            }
        });
    }, 300);
}


// WEBPACK FOOTER //
// src/assets/scripts/app.config.js